export default {
    "Welcome to financial": "Welcome to Financial",
};
